import React, { useEffect } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { RenderCategories } from "@components/RenderCategories";
import { logErrorToAPI } from "src/utils/errorLogger";
const AlgoliaSearch = dynamic(() => import("../AlgoliaSearch/AlgoliaSearch"));

const Error = (props) => {
  useEffect(() => {
    // Log the error to our API endpoint only if error is not empty
    if (props?.error && Object.keys(props.error).length > 0) {
      logErrorToAPI(props.error, {
        type: "error-boundary",
        errorId: Date.now().toString(),
      });
    }
  }, [props?.error]);

  return (
    <React.Fragment>
      <div className="err404-container topPadding">
        <div className="err404-header">
          <h1 className="err404-title">Oops!</h1>
          <h2 className="err404-subtitle">{props.message || "That page is missing"}</h2>
        </div>
        <div className="err404-search">
          <span className="err404-search-label">Try Again</span>
          <AlgoliaSearch classes="err404-search-box" />
          <p className="err404-back-home">
            Back to <Link href="/">Home</Link>
          </p>
        </div>
        <div className="err404-book-category">
          <div>
            <RenderCategories />
          </div>
          <div className="err404-book-container">
            <img
              src={`${process.env.S3_IMAGE_URL}/book.png`}
              className="err404-book-image"
              alt="error"
            />
          </div>
        </div>
      </div>
      <style>
        {`
          .err404-container {
            width: 40%;
            margin: 1rem auto;
            overflow: hidden;
          }
          .err404-header {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            text-align: center;
          }
          .err404-title {
            font-size: 8rem;
            margin: 15px auto;
          }
          .err404-subtitle {
            margin-top: 0px;
            font-size: 16pt;
            color: #3a7cbf;
          }
          .err404-search {
            margin: 1rem 0;
          }
          .err404-search-label {
            display: block;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 6px;
            color: #444;
          }
          .err404-search-box {
            margin: 10px 0;
            width: 100% !important;
            max-width: 100% !important
          }
          .err404-back-home {
            margin-top: 12px;
            font-size: 14px;
            color: #555;
          }
          .err404-back-home a {
            color: #3a7cbf;
            text-decoration: none;
          }
          .err404-back-home a:hover {
            text-decoration: underline;
          }
          .err404-book-category {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 1.5rem;
          }
          .err404-book-category:has(.listContainer) {
            justify-content: space-between;
          }
          .err404-book-image {
            width: 100%;
          }
          .err404-book-category .err404-book-container {
            max-width: 50%;
          }
          @media (max-width: 1024px) {
            .err404-container {
              width: 80%;
            }
          }
          @media (max-width: 768px) {
            .err404-container {
              width: 90%;
            }
          }
          @media (max-width: 575px) {
            .err404-book-category {
              flex-direction: column;
              margin-top: 20px;
            }
            .err404-book-category .err404-book-container,
            .err404-book-category .listContainer {
              max-width: 100%;
            }
            .err404-title {
              font-size: 4rem;
            }
          }
      `}
      </style>
    </React.Fragment>
  );
};
Error.Layout = SingleColumnLayout;
Error.displayName = "error";

export default Error;
